/* tempexp_18086-start */
import type { Space } from '@mail/cross-sizes-utils';
import { Text } from '@vkontakte/vkui';
import React, { useMemo } from 'react';
import { referralProgramBonusQuota, referralProgramHelpLink } from 'reactApp/appHelpers/featuresHelpers/features/referralProgram';
import { ButtonLink } from 'reactApp/ui/ButtonLink/ButtonLink';

import styles from './ReferralInfoBlock.css';
import { ReferralInfoBlockItem } from './ReferralInfoBlockItem';
interface ReferralInfoBlockProps {
    quota: Space;
    isMaxQuota: boolean;
    referralCount: number;
    isMobile?: boolean;
}

const buttonLink = (
    <ButtonLink primary size="medium" inline href={referralProgramHelpLink} target="_blank" fontInherit underline={false}>
        Подробнее
    </ButtonLink>
);

export function ReferralInfoBlock({ quota, referralCount, isMaxQuota, isMobile = false }: ReferralInfoBlockProps) {
    const noBonus = !quota.original;

    const quotaText = useMemo(
        () =>
            isMaxQuota ? (
                <>
                    Вы&nbsp;пригласили {referralCount}&nbsp;друзей&nbsp;&mdash; это бинго. Гигабайты больше не&nbsp;будут начисляться,
                    но&nbsp;новые друзья по‑прежнему могут получить скидку. {buttonLink}
                </>
            ) : (
                <>
                    Вы&nbsp;получаете {referralProgramBonusQuota.value} за&nbsp;каждого друга&nbsp;&mdash; пользуйтесь, пока его подписка
                    активна. {buttonLink}
                </>
            ),
        [isMaxQuota, referralCount]
    );

    return noBonus && !isMobile ? (
        <div className={styles.rootBlock}>
            <ReferralInfoBlockItem variant="1" text={'Пригласите друга по\u00A0реферальной ссылке'} />
            <ReferralInfoBlockItem variant="2" text={'Друг подключит любой тариф по\u00A0вашей ссылке'} />
            <ReferralInfoBlockItem
                variant="3"
                text={
                    <>
                        Он&nbsp;получит скидку,&nbsp;а&nbsp;вы&nbsp;{referralProgramBonusQuota.value}
                        <br />
                        {buttonLink}
                    </>
                }
            />
        </div>
    ) : (
        <Text className={styles.textBlock}>{quotaText}</Text>
    );
}

/* tempexp_18086-end */
